import { render, staticRenderFns } from "./NotificationNavbar.vue?vue&type=template&id=87a49b70&scoped=true"
import script from "./NotificationNavbar.vue?vue&type=script&lang=js"
export * from "./NotificationNavbar.vue?vue&type=script&lang=js"
import style0 from "./NotificationNavbar.vue?vue&type=style&index=0&id=87a49b70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a49b70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a49b70')) {
      api.createRecord('87a49b70', component.options)
    } else {
      api.reload('87a49b70', component.options)
    }
    module.hot.accept("./NotificationNavbar.vue?vue&type=template&id=87a49b70&scoped=true", function () {
      api.rerender('87a49b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/NotificationNavbar.vue"
export default component.exports